const BAYER = [
    [0, 8, 2, 10],
    [12, 4, 14, 6],
    [3, 11, 1, 9],
    [15, 7, 13, 5],
].map((row) => row.map((value) => (value + 0.5) / 16));

const BASE = [38, 44, 41];
const DIM = [52, 61, 56];

const glow = (x: number, y: number, cx: number, cy: number, radius: number) => {
    const dx = x - cx;
    const dy = y - cy;
    return Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy) / radius);
};

/**
 * 1비트 벽지: 어두운 회녹색 위에 4×4 베이어 디더로 찍은 빛 번짐.
 * 저해상도 그대로 셰이더 텍스처가 되어 픽셀이 뭉개지지 않는다.
 */
export const paintWallpaper = (width: number, height: number, pixel: number): HTMLCanvasElement => {
    const columns = Math.max(1, Math.ceil(width / pixel));
    const rows = Math.max(1, Math.ceil(height / pixel));
    const canvas = document.createElement('canvas');
    canvas.width = columns;
    canvas.height = rows;
    const context = canvas.getContext('2d')!;
    const image = context.createImageData(columns, rows);
    const aspect = columns / rows;

    for (let row = 0; row < rows; row += 1) {
        for (let column = 0; column < columns; column += 1) {
            const offset = (row * columns + column) * 4;
            const u = (column / columns) * aspect;
            const v = row / rows;
            const haze = glow(u, v, aspect * 0.5, 0.52, 1.1) * 0.62;
            const color = haze > BAYER[row % 4][column % 4] ? DIM : BASE;

            image.data[offset] = color[0];
            image.data[offset + 1] = color[1];
            image.data[offset + 2] = color[2];
            image.data[offset + 3] = 255;
        }
    }

    context.putImageData(image, 0, 0);
    return canvas;
};
